import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('shops'))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('shop?shop_id=' + data.shop_id))
  },

  async getSelf () {
    return store.dispatch('checkResponseApi', await Api().get('shop/self'))
  },

  async installApp (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/install_app', data, options))
  },

  async uninstallApp (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/uninstall_app', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop', data, options))
  },

  async updateSettings (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings', data, options))
  },

  async updateSettingsPOS (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/pos', data, options))
  },

  async updateSettingsPurchase (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/purchase', data, options))
  },

  async updateSettingsSale (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/sale', data, options))
  },

  async updateSettingsAccount (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/account', data, options))
  },

  async updateSettingsInventory (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/inventory', data, options))
  },

  async updateSettingsPayroll (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/payroll', data, options))
  },

  async updateSettingsExpense (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/settings/expense', data, options))
  },

  async getModuleTransactions () {
    return store.dispatch('checkResponseApi', await Api().get('shop/transaction-count-each-mudule'))
  },

  async clearData () {
    return store.dispatch('checkResponseApi', await Api().delete('shop/clear'))
  },

  async getUseLimit () {
    return store.dispatch('checkResponseApi', await Api().get('shop/use-limit'))
  },

  async getAvailableToCreate (type = '') {
    return store.dispatch('checkResponseApi', await Api().get(`shop/free-available/create/${type}`))
  },

  async updateBillingPreference (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('shop/billing/preferences', data, options))
  },
  async deactivateAccount () {
    return store.dispatch('checkResponseApi', await Api().post('shop/deactivate'))
  },

  async acknowledgeFreeTrialEnded () {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('shop/acknowledge/web/freetrial-ended', {}, options))
  },

  async getDiscounts () {
    return store.dispatch('checkResponseApi', await Api().get('shop/discounts'))
  },

}



// WEBPACK FOOTER //
// ./src/api/ShopService.js